import { NgModule, InjectionToken } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { LumiloginInterceptorService } from './service/lumilogin.interceptor.service';
import { LumiloginService } from './service/lumilogin.service';
import { LUMILOGIN_URL, LUMILOGIN_CLIENTID, LUMILOGIN_REALM, LUMILOGIN_SECRET, APPLICATION_NAME } from './lumilogin.token';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { HeaderComponent } from './header/header.component';
import { FooterComponent } from './footer/footer.component';
import { TranslateModule } from '@ngx-translate/core';

@NgModule({
  declarations: [HeaderComponent, FooterComponent],
  imports: [
    CommonModule,
    HttpClientModule,
    NgbModule,
    TranslateModule
  ],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: LumiloginInterceptorService,
      multi: true
    },
    LumiloginService
  ],
  exports: [
    HeaderComponent,
    FooterComponent
  ]
})
export class LumiloginModule { 
  static forRoot(lumilogin_url: string, lumilogin_realm: string, lumilogin_clientid: string, lumilogin_secret: string, application_name: string) {
    return {
      ngModule: LumiloginModule,
      providers: [
        {
          provide: LUMILOGIN_URL,
          useValue: lumilogin_url
        },
        {
          provide: LUMILOGIN_REALM,
          useValue: lumilogin_realm
        },
        {
          provide: LUMILOGIN_CLIENTID,
          useValue: lumilogin_clientid
        },
        {
          provide: LUMILOGIN_SECRET,
          useValue: lumilogin_secret
        },
        {
          provide: APPLICATION_NAME,
          useValue: application_name
        }
      ]
    }
  }
}